import axios from 'axios'
import {
  Message,
  Loading
} from 'element-ui'
import store from '@/store'
import {
  getToken
} from '@/utils/auth'
import pcRouter from '@/router'
let loadingBox = {}
// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API
  // baseURL: 'http://apidev3.ufwl.net/'
})

// request interceptor
service.interceptors.request.use(config => {
  // 官网首页做特殊处理，接口获取除getUserInfo外不携带token
  if (store.getters.token && (window.location.href.includes('backstage') || config.url === 'user/actor/get/user/info/saId')) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带token-- ['Authorization']为自定义key 请根据实际情况自行修改
  }
  if (config.params) {
    for (const k in config.params) {
      if (Array.isArray(config.params[k])) {
        config.params[k] = config.params[k].join(',')
      }
    }
  }
  config.headers['Content-Type'] = 'application/json'
  if (config.loading) {
    loadingBox = Loading.service({ fullscreen: true })
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  response => {
    loadingBox.close && loadingBox.close()
    var res = response.data
    if (res.code && res.code !== '200' && res.code !== 200) {
      res.code !== '403002' && Message({
        message: res.data || res.message,
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject(res)
    }
    return res
  },
  async error => {
    loadingBox.close && loadingBox.close()
    console.log('err' + error) // for debug
    const redirect = async () => {
      const router = pcRouter
      const isBackStage = window.location.href.includes('backstage')
      await store.dispatch('FedLogOut')
      isBackStage ? router.push('/login') : location.reload()
    }
    const res = error.response ? error.response.data : {}
    if (res) {
      if (res.code === '401004' || res.error === 'invalid_token') {
        redirect()
        // 官网首页做特殊处理，token过期不做提示
        if (!window.location.href.includes('backstage')) return
      }
      setTimeout(() => {
        Message.closeAll()
        Message({
          message: res.message,
          type: 'error',
          duration: 5 * 1000
        }, 100)
      })
    }
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js